export default {
    create_device_model_create_title: "Nuevo modelo de dispositivo",
    create_device_model_edit_title: "Editar modelo de dispositivo",
    create_device_model_create_success_message: "Se ha creado el modelo de dispositivo",
    create_device_model_update_success_message: "El modelo de dispositivo ha sido editado",
    create_device_model_manufacturer: "Fabricante",
    create_device_model_name: "Nombre",
    create_device_model_product: "Producto",
    create_device_model_system: "Sistema",
    create_device_model_network: "Red",
    create_device_model_inputs: "Número de Entradas",
    create_device_model_ouputs: "Número de Salidas",
    create_device_model_initial_battery: "Batería Inicial",
    create_device_model_mark_initial_battery: "Establecer batería inicial",
    create_device_model_options: "Opciones",
    create_device_model_ota: "OTA",
    create_device_model_sms: "SMS",
    create_device_model_starter: "Arrancador",
    create_device_model_driver_behavior: "Comportamiento del Conductor",
    create_device_model_analytic: "Analítica",
    create_device_model_uses_sim: "Usa SIM",
    create_device_model_motion: "Movimiento",
    create_device_model_obd2_alerts: "Alertas OBDII",
    create_device_model_hours_enable: "Horas Habilitado",
    create_device_model_odometer_enable: "Odometro Habilitado",
    create_device_model_promiles: "Promiles",
    create_device_model_comdata: "Comdata",
    create_device_model_pressure_pro: "Pressure Pro",
    create_device_model_vbus: "V-Bus",
    create_device_model_jbus: "J-Bus",
    create_device_model_tow: "Tow",
    create_device_model_ttu: "TTU",
    create_device_model_tso: "TSO",
    create_device_model_version: "Version",
    create_device_model_geofence: "Geocerca",
    create_device_model_max_geofences: "Geocercas Máximas",
    create_device_model_type: "Tipo",
    create_device_model_support_geofences: "Soporta Geocercas",
    create_device_model_polygon: "Polígono",
    create_device_model_regular_shape: "Forma Regular",
    create_device_model_max_points: "Puntos Máximos",
    create_device_model_square: "Cuadrado",
    create_device_model_circle: "Círculo",
    create_device_model_unit_type: "Tipo de Unidad",
    create_device_model_geofence_type_missing: "Se debe seleccionar una geocerca poligonal, cuadrada, circular o todas",
    create_device_model_geofence_form_missing: "Se debe seleccionar la forma de la geocerca que puede ser cuafrada, circular o ambas",
    create_device_model_min_points: "El minimo número de puntos debe ser 3",
    create_device_model_max_points_error: "El maximo número de puntos debe ser ",
    create_device_model_min_geofences: "El minimo número de geocercas debe ser 1",
    create_device_model_max_geofences_error: "El maximo número de geocercas debe ser",
    create_device_model_min_number: "El minimo número requerido es",
    create_device_model_max_number: "El maximo número requerido es",
    create_device_model_tab_general: "Información General",
    create_device_model_tab_options: "Opciones",
    create_device_model_tab_Geofences: "Geocercas",
    create_device_model_tab_alert_types: "Tipos de Alertas Soportadas",
    create_device_model_carb: "Carb",
}